/**
 * The page view reporting static details mapped by platform.
 * @type {Object<String>}
 */
export const PAGE_VIEW_DETAILS = {
    BIG_QUERY: {
        is_technical: true,
        group: 'page_view',
        type: 'page_view'
    }
};
